import React from "react";
import { SVGProps } from "../../svgData";

export default ({ defaultColor, selectedColor, isSelected }: SVGProps) => {
  const color = isSelected ? selectedColor : defaultColor;

  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="layer-group-solid 1" clipPath="url(#clip0_292_10880)">
        <path
          id="Vector"
          d="M9.18425 1.06934C9.70161 0.829753 10.2988 0.829753 10.8162 1.06934L18.4065 4.57628C18.7016 4.7117 18.8891 5.00684 18.8891 5.33322C18.8891 5.65961 18.7016 5.95475 18.4065 6.09017L10.8162 9.59711C10.2988 9.8367 9.70161 9.8367 9.18425 9.59711L1.59397 6.09017C1.29883 5.95128 1.11133 5.65614 1.11133 5.33322C1.11133 5.01031 1.29883 4.7117 1.59397 4.57628L9.18425 1.06934ZM16.5592 8.16656L18.4065 9.02073C18.7016 9.15614 18.8891 9.45128 18.8891 9.77767C18.8891 10.1041 18.7016 10.3992 18.4065 10.5346L10.8162 14.0416C10.2988 14.2811 9.70161 14.2811 9.18425 14.0416L1.59397 10.5346C1.29883 10.3957 1.11133 10.1006 1.11133 9.77767C1.11133 9.45475 1.29883 9.15614 1.59397 9.02073L3.44119 8.16656L8.71897 10.6041C9.53147 10.9791 10.469 10.9791 11.2815 10.6041L16.5592 8.16656ZM11.2815 15.0485L16.5592 12.611L18.4065 13.4652C18.7016 13.6006 18.8891 13.8957 18.8891 14.2221C18.8891 14.5485 18.7016 14.8436 18.4065 14.9791L10.8162 18.486C10.2988 18.7256 9.70161 18.7256 9.18425 18.486L1.59397 14.9791C1.29883 14.8402 1.11133 14.545 1.11133 14.2221C1.11133 13.8992 1.29883 13.6006 1.59397 13.4652L3.44119 12.611L8.71897 15.0485C9.53147 15.4235 10.469 15.4235 11.2815 15.0485Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_292_10880">
          <rect
            width="20"
            height="17.7778"
            fill="white"
            transform="translate(0 0.888672)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
